import router from '@/router'
import { stripPlatformHiddenPages, stripRemovedPages, stripDuplicatePreClassAnalysis, appendOrgUidToAnalysisPages, stripReportTemplatePages, ensureDomainBrandPage, ensureRuleConfigPage, stripDomainBrandFromRoleTree, ensurePreClassEduReportPage, ensureDataReportMenu, stripReportTemplateConfigFromRoleTree, stripAiAssistantMenuPages } from '@/utils/platformPages'
import { applySingleAnalysisNavTitle } from '@/utils/analysisMenu'
import { applySingleReportNavTitle } from '@/utils/reportMenu'
import { applyTabPermissions } from '@/utils/tabPages'
import { applyProjectDeviceTitle } from '@/utils/bidLevelActions.js'
import { Message } from 'element-ui'
import {
  sortArray,
  removeNull,
  getLevelArray,
  mergeSameKeys,
  getSameAttribute,
  getDistinct
} from '@/utils/handleData'
var Base64 = require('js-base64').Base64

const ORGAN_TYPE_ORDER = ['企业公司', '工程项目', '项目标段', '劳务公司']

function stripPagesByName(pages, names) {
  if (!Array.isArray(pages)) return pages
  return pages
    .filter((item) => names.indexOf(item.name) === -1)
    .map((item) => {
      if (item.children && item.children.length) {
        item.children = stripPagesByName(item.children, names)
      }
      return item
    })
}

function getOrgVType(item) {
  return (item && (item.vtype || item.vType || item.v_type)) || ''
}

function getOrganTypeLabel(item) {
  if (!item) return ''
  if (item.orgCode === '个人登录') return '个人机构'
  const vtype = getOrgVType(item)
  if (vtype === 'simPro') return '项目标段'
  if (vtype === 'com') return '企业公司'
  if (vtype === 'bigPro') return '工程项目'
  if (vtype === 'laborCom') return '劳务公司'
  return ''
}

function getUserTypeName(userType) {
  if (userType === 'qy') return '实体企业用户'
  if (userType === 'gc') return '工程项目用户'
  if (userType === 'xm') return '项目标段用户'
  if (userType === 'lw') return '劳务公司用户'
  if (userType === 'per') return '个人用户'
  return ''
}

const NON_ADMIN_ROLE_NAMES = [
  '项目级普通管理人员',
  '系统普通管理人员',
  '系统普通劳务人员',
  '系统普通个人用户',
  '个人档案'
]

function hasOrgAdminRole(roleName) {
  if (!roleName) return false
  const names = String(roleName)
    .split(/[,，、]/)
    .map((s) => s.trim())
    .filter((s) => s && s !== 'null' && s !== 'undefined')
  if (!names.length) return false
  return names.some((n) => {
    if (NON_ADMIN_ROLE_NAMES.includes(n)) return false
    return n.includes('管理员')
  })
}

function isPlatformAdminSession(state, organizations) {
  if (state && state.userName === 'dpnadmin') return true
  const orgs = organizations || (state && state.organizations) || []
  return orgs.some((item) => {
    return (
      item.orgCode === '甘肃大鹏鸟科技有限公司' ||
      item.orgName === '甘肃大鹏鸟科技有限公司'
    )
  })
}

function isPersonalOrg(item) {
  if (!item) return false
  return (
    item.orgCode === '个人登录' ||
    item.orgUid === 'org-default' ||
    item.organType === '个人机构'
  )
}

function uniqueByOrgUid(list) {
  const seen = new Set()
  return (list || []).filter((item) => {
    const id = item && (item.orgUid || item.uid)
    if (!id) return true
    if (seen.has(id)) return false
    seen.add(id)
    return true
  })
}

function comparePinyin(a, b) {
  const left = String(a || '').replace(/\(退场\)|（退场）/g, '')
  const right = String(b || '').replace(/\(退场\)|（退场）/g, '')
  return left.localeCompare(right, 'zh-CN', { numeric: true, sensitivity: 'accent' })
}

function isLaborExited(item) {
  if (!item) return false
  if (item.endTime) return true
  const code = item.orgCode || item.label || ''
  return code.indexOf('(退场)') >= 0 || code.indexOf('（退场）') >= 0
}

function bidStatusRank(item) {
  const status = (item && (item.buildStatus || item.buildstatus)) || ''
  if (status === '完工') return 1
  return 0
}

function laborStatusRank(item) {
  return isLaborExited(item) ? 1 : 0
}

function sortOrganGroup(organGroup) {
  const groups = (organGroup || []).slice().sort((a, b) => {
    const ai = ORGAN_TYPE_ORDER.indexOf(a.label)
    const bi = ORGAN_TYPE_ORDER.indexOf(b.label)
    const ao = ai < 0 ? ORGAN_TYPE_ORDER.length : ai
    const bo = bi < 0 ? ORGAN_TYPE_ORDER.length : bi
    if (ao !== bo) return ao - bo
    return comparePinyin(a.label, b.label)
  })
  groups.forEach((group) => {
    const children = uniqueByOrgUid(group.children || [])
    group.children = children.slice().sort((a, b) => {
      if (group.uid === 'simPro' || group.label === '项目标段') {
        const rank = bidStatusRank(a) - bidStatusRank(b)
        if (rank) return rank
      }
      if (group.uid === 'laborCom' || group.label === '劳务公司') {
        const rank = laborStatusRank(a) - laborStatusRank(b)
        if (rank) return rank
      }
      return comparePinyin(
        a.label || a.orgCode || a.orgName,
        b.label || b.orgCode || b.orgName
      )
    })
  })
  return groups
}

export default {
  namespaced: true,
  state: {
    userName: '', // 用户名
    telphoneNum: '', // 用户手机号
    passwd: '', // 用户密码
    personName: '', // 用户姓名
    userImage: '', // 用户头像
    userType: '', // 用户类型
    userPages: '', // 用户所有机构所有权限页面
    organizations: [], // 用户所有机构
    allOrgans: [], //系统所有机构信息
    orgValue: '', // 当前选择用户机构uid
    currentOrgUid: '', // 默认选择机构
    organUserList: {}, // 缓存查询到的机构用户列表
    personUserList: {}, // 缓存查询到的机构用户列表
    orgAllUser: [], // 缓存机构所属所有机构用户及个人用户
    orgAdmin: [], // 缓存机构下所有管理员用户
    orgNonAdmin: [], // 缓存机构下所有非管理员用户
    userRoles: [], // 用户默认角色组及角色
    webCapabilitiesByOrg: {}, // Web button actions by organization
    webCapabilityVersion: ''
  },
  getters: {
    organGroup: (state) => {
      let organizations = (state.organizations || []).map((item) => {
        const vtype = getOrgVType(item)
        return {
          ...item,
          vtype,
          organType: getOrganTypeLabel({ ...item, vtype })
        }
      })
      if (isPlatformAdminSession(state, organizations)) {
        organizations = organizations.filter((item) => !isPersonalOrg(item))
      }
      var params = {
        uid: 'vtype',
        label: 'organType',
        childUid: 'orgUid',
        childLabel: 'orgCode'
      }
      const organGroup = getLevelArray(organizations, params)
      return sortOrganGroup(organGroup)
    },
    organization: (state) => {
      var organization = {}
      if (state.organizations.length) {
        organization = state.organizations.find((item) => {
          return item.orgUid === state.orgValue
        }) || {}
      }
      return organization
    },
    // 当前选择用户机构名称
    orgName: (state, getters) => {
      return getters.organization.orgCode
    },
    isPlatformOrg: (state, getters) => {
      return getters.orgName === '甘肃大鹏鸟科技有限公司'
    },
    // 当前选择用户机构类型
    orgType: (state, getters) => {
      const org = getters.organization || {}
      const vtype = org.vtype || org.vType || org.v_type || ''
      if (vtype) return vtype
      const buildType = org.orgType || org.org_type || ''
      if (buildType === 'laborCom' || buildType === '劳务分包') return 'laborCom'
      if (buildType === 'simPro' || buildType === '项目标段') return 'simPro'
      if (buildType === 'com' || buildType === '企业') return 'com'
      if (buildType === 'bigPro' || buildType === '工程项目') return 'bigPro'
      return ''
    },
    // 当前选择用户机构参建类型
    orgBuildType: (state, getters) => {
      return getters.organization.orgType
    },
    // 当前选择用户机构工程类型
    projectType: (state, getters) => {
      return getters.organization.buildType
    },
    // 当前用户在当前选择机构中的角色
    orgUserRoles: (state) => {
      var roleList = []
      state.userRoles.forEach((item) => {
        if (item.organizeUid === state.orgValue) {
          roleList = roleList.concat(item.roleList)
        }
      })
      return getDistinct(roleList, 'roleCode')
    },
    // 当前用户机构下所有权限页面
    pages: (state, getters, rootState) => {
      var pages = []
      if (!state.userPages || !state.userPages.find) {
        return pages
      }
      const organization = state.userPages.find((item) => {
        return item.orgUid === state.orgValue
      })
      if (organization && organization.pages) {
        pages = JSON.parse(JSON.stringify(organization.pages))
        appendOrgUidToAnalysisPages(pages, state.orgValue)
      }
      pages = stripRemovedPages(pages)
      pages = stripDuplicatePreClassAnalysis(
        pages,
        '',
        getters.orgType || getters.orgBuildType
      )
      if (getters.isPlatformOrg) {
        pages = stripPlatformHiddenPages(pages)
      }
      pages = stripDomainBrandFromRoleTree(pages)
      pages = stripReportTemplateConfigFromRoleTree(pages)
      const adminName = (rootState && rootState.superAdminName) || 'dpnadmin'
      const isSuperAdmin =
        state.userName === adminName || state.personName === adminName
      const org = getters.organization || {}
      const isDpnOrg =
        getters.isPlatformOrg ||
        org.orgName === '甘肃大鹏鸟科技有限公司' ||
        org.orgCode === '甘肃大鹏鸟科技有限公司'
      if (isSuperAdmin && isDpnOrg) {
        pages = ensureDomainBrandPage(pages)
        pages = ensureDataReportMenu(pages)
      }
      if (isSuperAdmin) {
        pages = ensureRuleConfigPage(pages)
      }
      pages = ensurePreClassEduReportPage(pages)
      pages = applyTabPermissions(pages)
      if (!isDpnOrg) {
        pages = stripPagesByName(pages, ['organization', 'systemEngineeringModel'])
      }
      pages = sortArray(pages || [], ['index', 'pageName'], ['number'])
      return pages
    },
    currentWebCapabilities: (state) => {
      return state.webCapabilitiesByOrg[state.orgValue] || {}
    },
    hasWebAction: (state) => (actionCode) => {
      if (!actionCode) return true
      const capabilities = state.webCapabilitiesByOrg[state.orgValue] || {}
      return !!capabilities[actionCode]
    },
    // 当前用户机构下权限页面中导航页面
    menuPages: (state, getters) => {
      var menuPages = []
      if (getters.pages) {
        menuPages = JSON.parse(JSON.stringify(getters.pages))
        menuPages.some((item) => {
          if (item.name === 'workbench') {
            item.children = null
            return true
          }
        })
        applySingleAnalysisNavTitle(menuPages)
        applySingleReportNavTitle(menuPages)
        menuPages = stripReportTemplatePages(menuPages)
        menuPages = stripAiAssistantMenuPages(menuPages)
      }
      return menuPages
    },
    // 当前用户机构下权限页面中工作台全部应用页面
    workbenchApp: (state, getters) => {
      var workbenchApp = []
      if (getters.pages) {
        workbenchApp = getters.pages.filter((item) => {
          return item.name === 'workbench'
        })
      }
      return workbenchApp.length
        ? (workbenchApp[0].children || []).map((item) =>
            applyProjectDeviceTitle(item, getters.orgType)
          )
        : []
    },
    // 当前用户机构下权限页面中工作台个人应用
    // workbenchApp 已是扁平应用列表，不能再取 [0].children
    personalAPP: (state, getters) => {
      return (getters.workbenchApp || []).filter((item) => {
        return item && item.meta && item.meta.type === 'personalAPP'
      })
    },
    // 当前用户机构下权限页面中工作台项目应用
    projectAPP: (state, getters) => {
      return (getters.workbenchApp || []).filter((item) => {
        return item && item.meta && (item.meta.type === 'projectAPP' || !item.meta.type)
      })
    },
    // 当前用户机构下权限页面中工作台企业应用
    enterpriseApp: (state, getters) => {
      return (getters.workbenchApp || []).filter((item) => {
        return item && item.meta && item.meta.type === 'enterpriseApp'
      })
    }
  },
  actions: {
    /********************************************************** 用户管理 ********************************************************/

    // 后台新增个人用户
    async addPersonUser({ rootState, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/edit',
          data: data,
          msg:
            rootState.pageStatus.personUser !== 'batch'
              ? '新增个人用户成功'
              : '',
          noErrorMsg: rootState.pageStatus.personUser === 'batch'
        },
        { root: true }
      )
      return res
    },
    // 查询用户名是否存在
    async checkUserName({ dispatch }, userName) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/register/username',
          data: { userName: userName }
        },
        { root: true }
      )
      return res.data ? res.data : 0
    },
    // 查询电话号码是否存在
    async checktelphoneNum({ dispatch }, telphoneNum) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/register/telphonenum',
          data: { telphoneNum: telphoneNum }
        },
        { root: true }
      )
      return res.data ? res.data : 0
    },
    // 注册个人用户
    async register({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/login',
          data: data,
          msg: '注册用户成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑个人用户
    async editUser({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/user/useredit',
          data: data,
          msg: '编辑用户信息成功'
        },
        { root: true }
      )
      return res
    },
    // 用户修改登录密码或更换手机号码
    async editPassWord({ state, commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/appuser/update',
          data: data,
          msg: data.telphoneNum ? '更换手机号码成功' : '修改登录密码成功'
        },
        { root: true }
      )
      if (res.code !== 200) return
      commit(
        'baseSet',
        {
          module: 'user',
          key: 'telphoneNum',
          value: data.telphoneNum ? data.telphoneNum : state.telphoneNum
        },
        { root: true }
      )
      return res
    },
    // 用户修改用户信息（含默认登录显示机构）
    async editPerUserInfo({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/rule/appuser/currentorguid',
          data: data,
          msg:
            data && data.editType === 'currentOrg'
              ? '默认机构已更新'
              : '编辑用户信息成功'
        },
        { root: true }
      )
      if (res.code !== 200) return
      if (data && data.userName) {
        commit(
          'baseSet',
          { module: 'user', key: 'userName', value: data.userName },
          { root: true }
        )
      }
      // 保存默认机构后立即切换当前展示机构（与小程序一致）
      if (data && data.currentOrgUid) {
        commit(
          'baseSet',
          { module: 'user', key: 'currentOrgUid', value: data.currentOrgUid },
          { root: true }
        )
        commit(
          'baseSet',
          { module: 'user', key: 'orgValue', value: data.currentOrgUid },
          { root: true }
        )
      }
      return res
    },
    // 初始化用户密码
    async resetPassWord({ dispatch }, params) {
      var data = {
        uid: params.userUid,
        userType: params.userType ? params.userType : 'per'
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/user/initpasswd',
          data: data,
          msg: '密码初始化成功'
        },
        { root: true }
      )
      return res
    },
    // 登录前校验是否需要手机安全验证
    async checkPersonLogin({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/logincheck',
          data: data,
          noErrorMsg: true
        },
        { root: true }
      )
      return res
    },
    // 个人用户手机验证码登录
    async smsLogin({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/smslogin',
          data: data,
          noErrorMsg: true
        },
        { root: true }
      )
      return res
    },
    // 重复手机号账号的短信安全验证
    async dualAuthLogin({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/dualauth',
          data: data,
          msg: '安全验证成功'
        },
        { root: true }
      )
      return res
    },
    // 个人用户登录
    async userlogin({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/base/login',
          data: data,
          header: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
          },
          msg: '登录成功'
        },
        { root: true }
      )
      if (!res.token) return
      commit('baseSet', { key: 'token', value: res.token }, { root: true })
      window.sessionStorage.setItem('token', res.token)
      commit(
        'baseSet',
        { module: 'user', key: 'userName', value: data.userName },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'user', key: 'passwd', value: data.passwd },
        { root: true }
      )
      await dispatch('getUser')
      await dispatch('getUserRights')
      await dispatch('getUserPages')
      await dispatch('getOrganizations')
      router.push('/home')
    },
    // 获取人员头像及姓名
    async getUser({ rootState, commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/person/facesluidimage' },
        { root: true }
      )
      // console.log(res)
      const data = (res && res.data) || {}
      let faceSluid = data.faceSluid
      if (!faceSluid || faceSluid === '08e62f56-3ee1-4d1b-a3d0-8a3156216321') {
        const def = await dispatch(
          'baseRequest',
          { method: 'GET', url: '/person/list/personinfo/defaultface', noErrorMsg: true },
          { root: true }
        )
        if (def && def.data) faceSluid = def.data
        if (!faceSluid) faceSluid = '08e62f56-3ee1-4d1b-a3d0-8a3156216321'
      }
      if (faceSluid) {
        const image =
          rootState.baseURL +
          rootState.uploadFaceimage +
          '/' +
          faceSluid +
          '/64_64_80' +
          '?token=' +
          Base64.encode(window.sessionStorage.getItem('token'))
        if (data.userName) {
          commit(
            'baseSet',
            { module: 'user', key: 'personName', value: data.userName },
            { root: true }
          )
        }
        commit(
          'baseSet',
          { module: 'user', key: 'telphoneNum', value: data.telphoneNum },
          { root: true }
        )
        commit(
          'baseSet',
          { module: 'user', key: 'userType', value: data.userType },
          { root: true }
        )
        commit(
          'baseSet',
          { module: 'user', key: 'userImage', value: image },
          { root: true }
        )
      }
    },
    // 获取用户组织权限页面
    async getUserPages({ state, commit, dispatch }, options) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/rule/user/lqpage' },
        { root: true }
      )
      // console.log(res)
      const rawPages = res && res.data ? res.data : []
      var userPages = rawPages.filter((item) => !item.banned)
      const bannedPages = rawPages.filter((item) => item.banned)
      const capabilitiesByOrg = {}
      let capabilityVersion = ''
      rawPages.forEach((item) => {
        if (!item || !item.orgUid) return
        if (item.capabilities && typeof item.capabilities === 'object') {
          capabilitiesByOrg[item.orgUid] = item.capabilities
        }
        if (item.capabilityVersion) {
          capabilityVersion = item.capabilityVersion
        }
      })
      var dpnkj = userPages.find((item) => {
        return item.orgCode === '甘肃大鹏鸟科技有限公司'
      })
      if (isPlatformAdminSession(state, userPages)) {
        userPages = userPages.filter((item) => !isPersonalOrg(item))
      }
      userPages.forEach((item) => {
        item.pages = sortArray(item.pages || [], ['index'], ['number'])
      })
      commit(
        'baseSet',
        { module: 'user', key: 'userPages', value: userPages },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'user', key: 'organizations', value: userPages },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'user',
          key: 'webCapabilitiesByOrg',
          value: capabilitiesByOrg
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'user',
          key: 'webCapabilityVersion',
          value: capabilityVersion
        },
        { root: true }
      )
      if (bannedPages.length) {
        Message.warning('当前机构被封禁，请联系管理员获取权限')
      }
      if (userPages.length) {
        const keepOrg = options && options.keepOrg
        const prevOrg = state.orgValue
        const preferredUid = userPages[0].currentOrgUid
        const preferred = userPages.find((item) => item.orgUid === preferredUid)
        const keepCurrent =
          keepOrg && prevOrg && userPages.find((item) => item.orgUid === prevOrg)
        const orgUid = keepCurrent
          ? prevOrg
          : isPlatformAdminSession(state, userPages) && dpnkj
          ? dpnkj.orgUid
          : preferred
          ? preferred.orgUid
          : dpnkj
          ? dpnkj.orgUid
          : userPages[0].orgUid
        commit(
          'baseSet',
          {
            module: 'user',
            key: 'currentOrgUid',
            value: orgUid
          },
          { root: true }
        )
        commit(
          'baseSet',
          {
            module: 'user',
            key: 'orgValue',
            value: orgUid
          },
          { root: true }
        )
      }
    },
    // 获取用户组织信息
    async getOrganizations({ state, commit, dispatch }, orgUids) {
      var params = orgUids
        ? orgUids
        : getSameAttribute(state.organizations, 'orgUid').values
      const res = await dispatch(
        'baseRequest',
        { method: 'POST', url: '/organize/org/uplevel', data: params },
        { root: true }
      )
      var organizations = res.data ? res.data : state.organizations
      if (isPlatformAdminSession(state, organizations)) {
        organizations = (organizations || []).filter((item) => !isPersonalOrg(item))
      }
      organizations.forEach((item) => {
        item.vtype = getOrgVType(item)
        item.organType = getOrganTypeLabel(item)
        if (item.vtype === 'laborCom') {
          const upList = item.upOrg || []
          const upOrg =
            upList.find((org) => {
              return (
                org.professionalNature === '管控' &&
                org.professionalType === '直属标段'
              )
            }) || upList.find((org) => org.professionalType === '直属标段')
          const prefix = upOrg && upOrg.orgCode ? upOrg.orgCode : '未知标段'
          const raw = item.orgCode || item.orgName || ''
          const already =
            raw === prefix || (prefix && raw.indexOf(prefix + '/') === 0)
          if (!already) {
            item.orgCode = prefix + '/' + raw
          }
          if (item.endTime && String(item.orgCode).indexOf('(退场)') < 0) {
            item.orgCode = item.orgCode + '(退场)'
          }
        }
      })
      commit(
        'baseSet',
        { module: 'user', key: 'organizations', value: organizations },
        { root: true }
      )
      try {
        await dispatch(
          'bidSection/syncLaborBidContext',
          { organizations },
          { root: true }
        )
      } catch (e) {
        // 标段上下文仅用于业务查询，不能阻断登录和机构切换
      }
    },
    // 获取系统所有机构信息
    async getAllOrgans({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/org/all' },
        { root: true }
      )
      var allOrgans = res.data ? res.data : []
      allOrgans = allOrgans
        .map((item) => {
          const vtype = getOrgVType(item)
          return {
            ...item,
            vtype,
            organType: getOrganTypeLabel({ ...item, vtype })
          }
        })
        .filter((item) => {
          return (
            item.vtype === 'com' ||
            item.vtype === 'bigPro' ||
            item.vtype === 'simPro' ||
            item.vtype === 'laborCom'
          )
        })
      allOrgans = uniqueByOrgUid(allOrgans)
      var params = {
        uid: 'vtype',
        label: 'organType',
        childUid: 'orgUid',
        childLabel: 'orgCode'
      }
      allOrgans = getLevelArray(allOrgans, params)
      allOrgans = sortOrganGroup(allOrgans)
      commit(
        'baseSet',
        { module: 'user', key: 'allOrgans', value: allOrgans },
        { root: true }
      )
    },
    async getChildOrgans({ commit, dispatch, rootState }) {
      const orgUid = rootState.user && rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/org/children', data: { orgUid } },
        { root: true }
      )
      var allOrgans = res.data ? res.data : []
      allOrgans = allOrgans
        .map((item) => {
          const vtype = getOrgVType(item)
          return {
            ...item,
            vtype,
            organType: getOrganTypeLabel({ ...item, vtype })
          }
        })
        .filter((item) => {
          return (
            item.vtype === 'com' ||
            item.vtype === 'bigPro' ||
            item.vtype === 'simPro' ||
            item.vtype === 'laborCom'
          )
        })
      allOrgans = uniqueByOrgUid(allOrgans)
      var params = {
        uid: 'vtype',
        label: 'organType',
        childUid: 'orgUid',
        childLabel: 'orgCode'
      }
      allOrgans = getLevelArray(allOrgans, params)
      allOrgans = sortOrganGroup(allOrgans)
      commit(
        'baseSet',
        { module: 'user', key: 'allOrgans', value: allOrgans },
        { root: true }
      )
    },
    // 获取系统所有机构用户
    async getSystemOrganUser({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.organUser
      queryValues.page = rootState.page.organUser
      queryValues.limit = rootState.limit.organUser
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/orguser/list',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      if (res.data && res.data.result) {
        res.data.result.forEach((item) => {
          item.userTypeName = getUserTypeName(item.userType)
        })
        await dispatch('fillPersonUserStatus', {
          rows: res.data.result,
          type: 'organ'
        })
        commit(
          'baseSet',
          { module: 'user', key: 'organUserList', value: res.data },
          { root: true }
        )
      }
    },
    async getOrgAdmin({ rootState, commit, dispatch }, data) {
      var queryValues = data
        ? Object.assign({}, data)
        : Object.assign({}, rootState.queryValues.orgAdmin || {})
      const fullCandidates = !!(data && (data.forCandidate || data.limit))
      queryValues.page = fullCandidates ? 1 : rootState.page.orgAdmin || 1
      queryValues.limit = fullCandidates
        ? data.limit || 500
        : rootState.limit.orgAdmin || 10
      queryValues = removeNull(queryValues)
      const orgUid = queryValues.orgUid || rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/finduser/orguid', data: queryValues },
        { root: true }
      )
      let rows = []
      if (Array.isArray(res.data)) {
        rows = res.data.slice()
      } else if (res.data && Array.isArray(res.data.result)) {
        rows = res.data.result.slice()
      }
      if (orgUid) {
        const orgRes = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/orguser/byorg',
            data: { orgUid }
          },
          { root: true }
        )
        const orgRows = Array.isArray(orgRes.data) ? orgRes.data : []
        const byUid = {}
        rows.forEach((item) => {
          if (item && item.userUid) byUid[String(item.userUid)] = item
        })
        orgRows.forEach((item) => {
          if (!item || !item.userUid) return
          const key = String(item.userUid)
          const current = byUid[key]
          if (!current) {
            byUid[key] = item
            rows.push(item)
            return
          }
          if (!current.personName && !current.personname && !current.name) {
            current.personName =
              item.personName || item.personname || item.name || ''
          }
          if (!current.telphoneNum && item.telphoneNum) {
            current.telphoneNum = item.telphoneNum
          }
          if (!current.roleName && item.roleName) {
            current.roleName = item.roleName
          } else if (
            current.roleName &&
            item.roleName &&
            String(current.roleName).indexOf(item.roleName) === -1
          ) {
            current.roleName = current.roleName + '、' + item.roleName
          }
        })
      }
      if (rows.length) {
        rows = mergeSameKeys(rows, {
          uidKey: 'userUid',
          joinKey: 'roleName'
        })
        await dispatch('fillPersonUserStatus', {
          rows: rows,
          type: 'organ'
        })
      }
      rows.forEach((item) => {
        item.userTypeName = getUserTypeName(item.userType)
        item.personName =
          item.personName ||
          item.personname ||
          item.name ||
          item.loginPersonName ||
          ''
        item.userCode = item.personName
          ? item.personName
          : item.orgName || item.orgCode || ''
        item.name = item.personName ? item.personName : undefined
        item.orgCode = item.orgName ? item.orgName : item.orgCode
      })
      const orgAdmin = rows.filter(
        (item) =>
          hasOrgAdminRole(item.roleName) ||
          ['qy', 'gc', 'xm', 'lw'].indexOf(item.userType) !== -1
      )
      const orgNonAdmin = rows.filter(
        (item) => !hasOrgAdminRole(item.roleName)
      )
      commit(
        'baseSet',
        { module: 'user', key: 'orgAllUser', value: rows },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'user', key: 'orgAdmin', value: orgAdmin },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'user', key: 'orgNonAdmin', value: orgNonAdmin },
        { root: true }
      )
    },
    // 获取系统所有个人用户
    async getSystemPersonUser({ rootState, commit, dispatch }, data) {
      const searching = !!(data && data.queryName !== undefined)
      var queryValues = data
        ? Object.assign({}, rootState.queryValues.personUser || {}, data)
        : Object.assign({}, rootState.queryValues.personUser || {})
      if (searching) {
        queryValues.page = data.page || 1
        queryValues.limit = data.limit || 50
      } else {
        queryValues.page = rootState.page.personUser
          ? rootState.page.personUser
          : 1
        queryValues.limit = rootState.limit.personUser
          ? rootState.limit.personUser
          : 10
      }
      queryValues = removeNull(queryValues)
      if (!rootState.person.aligned) {
        try {
          await dispatch('person/alignPersonUser', null, { root: true })
        } catch (e) {
          /* ignore */
        }
        commit(
          'baseSet',
          { module: 'person', key: 'aligned', value: true },
          { root: true }
        )
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/personinfo/userlist',
          data: queryValues
        },
        { root: true }
      )
      if (res.data && res.data.result) {
        await dispatch('fillPersonUserStatus', {
          rows: res.data.result,
          type: 'person'
        })
      }
      if (!searching) {
        commit(
          'baseSet',
          {
            module: 'user',
            key: 'personUserList',
            value: res.data ? res.data : []
          },
          { root: true }
        )
      }
      return res.data ? res.data : []
    },
    async fillPersonUserStatus({ dispatch }, payload) {
      const rows = payload && payload.rows ? payload.rows : payload
      const type = payload && payload.type ? payload.type : 'person'
      if (!rows || !rows.length) {
        return rows
      }
      const userUids = rows
        .map((item) => item.userUid || item.uid)
        .filter((item) => item)
      if (!userUids.length) {
        return rows
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/list/personinfo/userstatus',
          data: { userUids: userUids.join(',') },
          noErrorMsg: true
        },
        { root: true }
      )
      const statusMap = {}
      const list = Array.isArray(res.data) ? res.data : []
      list.forEach((item) => {
        const uid = item.userUid || item.useruid || item.uid
        if (uid) {
          statusMap[uid] = item
        }
      })
      rows.forEach((item) => {
        const uid = item.userUid || item.uid
        const status = statusMap[uid] || {}
        const isBan = status.isBan || status.isban || '0'
        const isOrgBan = status.isOrgBan || status.isorgban || '0'
        const hasArchive = status.hasArchive || status.hasarchive || '0'
        const archiveStatus = status.archiveStatus || status.archivestatus || '1'
        item.isBan = isBan
        item.isOrgBan = isOrgBan
        item.hasArchive = hasArchive
        item.archiveStatus = archiveStatus
        item.personUid = status.personUid || status.personuid || item.personUid
        if (
          !item.personName &&
          !item.personname &&
          !item.name &&
          (status.personName || status.personname)
        ) {
          item.personName = status.personName || status.personname
        }
        item.accountStatusName =
          isBan === '1' ? '封禁' : isOrgBan === '1' ? '个人机构封禁' : '正常'
        item.archiveStatusName =
          hasArchive !== '1'
            ? '未关联'
            : archiveStatus === '0'
            ? '已封存'
            : '已关联'
        if (type === 'organ') {
          item.disabledButtons = isBan === '1' ? [1] : [2]
        } else {
          const disabled = []
          if (isBan === '1' || isOrgBan === '1') {
            disabled.push(1)
          } else {
            disabled.push(2)
          }
          if (hasArchive === '1' && isBan !== '1') {
            disabled.push(3)
          }
          item.disabledButtons = disabled
        }
      })
      return rows
    },
    // 获取用户全部角色组及默认角色
    async getUserRights({ commit, dispatch }, userUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/user/roleinfo',
          data: {
            uid: userUid
          }
        },
        { root: true }
      )
      // console.log(res)
      var userRoles = res.data ? res.data : []
      commit(
        'baseSet',
        { module: 'user', key: 'userRoles', value: userRoles },
        { root: true }
      )
      return userRoles
    },
    // 获取用户全部角色组及默认角色
    async getUserRoles({ rootState, rootGetters, commit, dispatch }, userUid) {
      var params = {
        personUserUid: userUid,
        orgUid:
          rootGetters['user/orgName'] !== '甘肃大鹏鸟科技有限公司'
            ? rootState.user.orgValue
            : null
      }
      params = removeNull(params)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/jurisdiction/userdetail',
          data: params
        },
        { root: true }
      )
      // console.log(res)
      const obj = {
        uid: 'roleGroupUid',
        label: 'roleGroupName',
        childUid: 'roleUid',
        childLabel: 'roleName',
        keepKeys: ['organizeUid']
      }
      var userRoles = getLevelArray(res.data ? res.data : [], obj)
      userRoles.forEach((item) => {
        if (!item.label) return
        item.label = String(item.label)
          .replace(/实名制管理员角色组$/, '角色组')
          .replace(/机构用户角色组$/, '角色组')
      })
      commit(
        'baseSet',
        { module: 'user', key: 'userRoles', value: userRoles },
        { root: true }
      )
      return userRoles
    },
    // 配置用户的角色组中角色
    async setUserRoles({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/role/edit',
          data: data,
          msg: '配置角色成功'
        },
        { root: true }
      )
      return res
    },
    // 新增用户角色组及角色
    async addRoleGroup({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/role/group',
          data: data,
          msg: '添加角色组及角色成功'
        },
        { root: true }
      )
      return res
    },
    async banUsers({ dispatch }, data) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/ban',
          data: data,
          msg: '封禁成功'
        },
        { root: true }
      )
    },
    async unbanUsers({ dispatch }, data) {
      return dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/rule/user/unban',
          data: data,
          msg: '解禁成功'
        },
        { root: true }
      )
    }
  }
}
